import { createAppSlice } from 'app/createAppSlice'
import {
  fetchInventoryGroups,
  getGroupInventory,
  getInventory,
  getInventorySummary,
  getPackingDetail,
  getWarehouse,
  getWarehouseForAdd,
  getItemsInventory,
  getLandplot,
} from './manageStockAction'

export const initialState = {
  loading: false,
  groupsInventory: null,
  detail: null,
  warehouses: null,
  warehousesAdd: null,
  defaultWarehouse: null,
  itemsInventory: [],
  inventoryList: [],
  inventoryTotalItems: 0,
  inventoryTotalPages: 0,
  inventoryCurrentPage: 0,
  qrPrintingInventoryCache: [],
  qrPrintingInventoryFetchedAt: null,
  landplots: null,
  inventorySummary: null,
  inventorySummaryAll: null,
}

export const manageStockSlice = createAppSlice({
  name: 'manageStock',
  initialState,
  reducers: (create) => ({
    setQrPrintingInventoryCache: create.reducer((state, { payload }) => {
      state.qrPrintingInventoryCache = Array.isArray(payload) ? payload : []
      state.qrPrintingInventoryFetchedAt = Date.now()
    }),
  }),
  extraReducers: (builder) => {
    builder
      .addCase(getGroupInventory.pending, (state) => {
        if (!state.groupsInventory || state.groupsInventory?.items?.length === 0) {
          state.loading = true
        }
      })
      .addCase(getGroupInventory.fulfilled, (state, { payload }) => {
        state.loading = false
        state.groupsInventory = payload
      })
      .addCase(getGroupInventory.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getPackingDetail.pending, (state) => {
        state.loading = true
      })
      .addCase(getPackingDetail.fulfilled, (state, { payload }) => {
        state.loading = false
        state.detail = payload
      })
      .addCase(getPackingDetail.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getWarehouse.pending, (state) => {
        state.loading = true
      })
      .addCase(getWarehouse.fulfilled, (state, { payload }) => {
        state.loading = false
        state.warehouses = payload

        // SET DEFAULT WAREHOUSE FOR FILTERS
        const storedWarehouse = JSON.parse(
          localStorage.getItem('defaultWarehouseInventory'),
        )
        const masterWarehouses = payload?.newData

        const validWarehouse = masterWarehouses?.find(
          (warehouse) => warehouse.id === storedWarehouse?.id,
        )

        if (!validWarehouse && masterWarehouses?.length > 0) {
          const defaultWarehouse = masterWarehouses[0]
          localStorage.setItem(
            'defaultWarehouseInventory',
            JSON.stringify(defaultWarehouse),
          )
        }
      })
      .addCase(getWarehouse.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getWarehouseForAdd.pending, (state) => {
        state.loading = true
      })
      .addCase(getWarehouseForAdd.fulfilled, (state, { payload }) => {
        state.loading = false
        state.warehousesAdd = payload
      })
      .addCase(getWarehouseForAdd.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(fetchInventoryGroups.pending, (state) => {
        if (!state.groupsInventory || state.groupsInventory?.items?.length === 0) {
          state.loading = true
        }
      })
      .addCase(fetchInventoryGroups.fulfilled, (state, action) => {
        state.loading = false
        state.groupsInventory = action.payload
      })
      .addCase(fetchInventoryGroups.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getItemsInventory.pending, (state) => {
        state.loading = true
      })
      .addCase(getItemsInventory.fulfilled, (state, { payload }) => {
        state.loading = false
        state.itemsInventory = payload?.items
      })
      .addCase(getItemsInventory.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getLandplot.pending, (state) => {
        state.loading = true
      })
      .addCase(getLandplot.fulfilled, (state, { payload }) => {
        state.loading = false
        state.landplots = payload
      })
      .addCase(getLandplot.rejected, (state, { payload }) => {
        state.loading = false
      })
      .addCase(getInventory.pending, (state) => {
        if (!state.inventoryList || state.inventoryList.length === 0) {
          state.loading = true
        }
      })
      .addCase(getInventory.fulfilled, (state, { payload }) => {
        state.loading = false
        state.inventoryList = payload?.items || []
        state.inventoryTotalItems = payload?.totalItems || 0
        state.inventoryTotalPages = payload?.totalPages || 0
        state.inventoryCurrentPage = payload?.currentPage || 0
      })
      .addCase(getInventory.rejected, (state) => {
        state.loading = false
      })
      .addCase(getInventorySummary.pending, (state) => {
        if (!state.inventorySummary || state.inventorySummary.items?.length === 0) {
          state.loadingSummary = true
        }
      })
      .addCase(getInventorySummary.fulfilled, (state, action) => {
        state.loadingSummary = false
        if (action.meta.arg.size === 9999) {
          state.inventorySummaryAll = action.payload
        } else {
          state.inventorySummary = action.payload
        }
      })
      .addCase(getInventorySummary.rejected, (state) => {
        state.loadingSummary = false
      })
  },
})
export const {
  resetAlert,
  addRole,
  logout,
  login,
  loginLoading,
  loginReject,
  toggleAlert,
  setAlertMsg,
  setInitAlert,
  toggleModal,
  setLoading,
  setToken,
  setQrPrintingInventoryCache,
} = manageStockSlice.actions
export default manageStockSlice.reducer
